import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { ADMIN_PLAYER_PROFILE_ROUTE_NAME } from '@modules/players/submodules/PlayerProfile/constants';
import {
  PLAYER_ACTIVITY_ROUTE,
  TRANSLATION_GROUP_PLAYER_ACTIVITY,
} from '@modules/players/submodules/PlayerProfile/submodules/PlayerActivity/constants';
import { getTranslationKeys } from '@modules/players/submodules/PlayerProfile/submodules/PlayerActivity/translations';

export class PlayerActivityModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PLAYER_PROFILE_ROUTE_NAME, {
      name: PLAYER_ACTIVITY_ROUTE,
      path: 'player_activity',
      component: () => import('@modules/players/submodules/PlayerProfile/submodules/PlayerActivity/pages/PlayerActivityPage/PlayerActivityPage.vue'),
      permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_PLAYER_ACTIVITY, getTranslationKeys);
  }
}
